import Cookies from "js-cookie";

const cookieName = 'recommendations_clicked';

export const getRecommendationsClicked = () => Boolean(Cookies.get(cookieName));
export const setRecommendationsClicked = () => Cookies.set(cookieName, 'true', { expires: 3 });
